exports.__stringFrom = require('../$str/str.js').__str;
exports.stringFrom = require('../$str/str.js').str;